module.exports = __webpack_public_path__ + "img/weixin.7c182d1a.png";